import { render } from "./OverlayAside.vue?vue&type=template&id=37f81904&scoped=true&ts=true"
import script from "./OverlayAside.vue?vue&type=script&lang=ts"
export * from "./OverlayAside.vue?vue&type=script&lang=ts"

import "./OverlayAside.vue?vue&type=style&index=0&id=37f81904&lang=scss&scoped=true"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f81904"]])

export default __exports__